export class DataStore {
    serverKey: string = '';

    userKey: string = '';
    passwordKey: string = '';

    authenticated: boolean = false;
}